import { render, staticRenderFns } from "./pop-img-slides.vue?vue&type=template&id=0bf53f86&scoped=true"
import script from "./pop-img-slides.vue?vue&type=script&lang=js"
export * from "./pop-img-slides.vue?vue&type=script&lang=js"
import style0 from "./pop-img-slides.vue?vue&type=style&index=0&id=0bf53f86&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf53f86",
  null
  
)

export default component.exports